module.exports = __webpack_public_path__ + "img/area-4-2.73c58ff.jpg";